module.exports = __webpack_public_path__ + "static/media/space-configuration-icon.5f2c4bab.svg";